import styled from 'styled-components';
export default styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;



// WEBPACK FOOTER //
// ./src/incab/common/components/Box.jsx